module.exports = __webpack_public_path__ + "static/media/mode-68.a57e78e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-68.svg
// module id = 1039
// module chunks = 2